import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=155463ca&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155463ca')) {
      api.createRecord('155463ca', component.options)
    } else {
      api.reload('155463ca', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=155463ca&", function () {
      api.rerender('155463ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u1eON4XuzoIb/JS/comp/pricelist.vue"
export default component.exports